import { render, staticRenderFns } from "./b2.vue?vue&type=template&id=5c3202ce&scoped=true"
import script from "./b2.vue?vue&type=script&lang=js"
export * from "./b2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3202ce",
  null
  
)

export default component.exports